import React from "react";
import LinkedInIcon from "../assets/LinkedIn.png";
import FacebookIcon from "../assets/Frame 26086073.png";
import GlobeIcon from "../assets/Frame 26086075.png";
import PhoneIcon from "../assets/phone.png";
import EmailIcon from "../assets/email.png";
import IndustryIcon from "../assets/Category.png";
import WomenOwnedIcon from "../assets/Woman 2.png";
import ArrowIcon from "../assets/Vector.png";

const BusinessCard = ({ business }) => {
  const [imgSrc, setImgSrc] = React.useState(
    business.image ||
      business.businessLogoUrl ||
      "https://placehold.co/44x44?text=Logo"
  );

  // Determine if this is a business or professional record
  const isBusiness =
    business.occupation?.toLowerCase() === "business" ||
    (business.company_name && !business.name);

  const mappedBusiness = {
    isBusiness,
    name: isBusiness
      ? business.company_name || business.name || "Untitled Business"
      : business.name || "Professional",
    subtitle: isBusiness
      ? business.name
        ? { value: business.name }
        : null
      : business.designation
      ? { value: business.designation }
      : null,
    company_name: business.company_name || "",
    type: business.occupation,
    services: business.designation || "",
    email: business.email || "",
    details: business.description,
    occupation: business.occupation,
    other_service: business.other_service,
    contact: business.contact || "",
    industryTypes: business.industry ? [business.industry] : [],
    badges: [...(business.badges || [])],
    internship: business.internship,
    designation: business.designation,
    social: {
      linkedin: business.linkedin,
      facebook: "",
      website: business.website,
    },
    logo: business.logo,
  };

  // Add occupation to badges if not already present
  if (
    business.occupation &&
    !mappedBusiness.badges.includes(business.occupation)
  ) {
    mappedBusiness.badges.unshift(business.occupation);
  }

  return (
    <div
      className={`relative flex flex-col p-4 mb-6 w-full rounded-xl font-[Segoe UI] bg-white transition-transform duration-300 border border-[#E0E0E0] shadow-md hover:shadow-lg ${
        mappedBusiness.isBusiness ? "business-card" : "professional-card"
      }`}
    >
      <div className="flex items-center mb-2 justify-between">
        {/* Sponsor Badges */}
        <div className="">
          {business.level2_sponsored && (
            <div>
              <span className="flex items-center gap-1 w-fit bg-purple-600 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow-md z-20 border border-purple-500">
                <svg
                  className="w-3 h-3 mr-0.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                Premium Sponsor
              </span>
            </div>
          )}
          {business.sponsored && !business.level2_sponsored && (
            <div>
              <span className="flex items-center gap-1 w-fit bg-yellow-400 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow-md z-20 border border-yellow-300">
                <svg
                  className="w-3 h-3 mr-0.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                Sponsored
              </span>
            </div>
          )}
        </div>
        {mappedBusiness.social.website && (
          <a
            href={
              mappedBusiness.social.website?.startsWith("http")
                ? mappedBusiness.social.website
                : `https://${mappedBusiness.social.website}`
            }
            target="_blank"
            rel="noopener noreferrer"
            className=" w-9 h-9 flex items-center justify-center hover:border-[1.5px] hover:border-[#f5b041] transition rounded"
            title="Open Website"
          >
            <img src={ArrowIcon} alt="Website" className="w-6 h-6" />
          </a>
        )}
      </div>

      <div className="flex flex-col sm:flex-row items-start gap-4 w-full mb-3">
        <div className="relative w-20 h-20 sm:w-24 sm:h-24 flex-shrink-0">
          <div className="w-full h-full flex items-center justify-center rounded-lg bg-gray-50 border border-gray-200 overflow-hidden">
            {mappedBusiness.social.website ? (
              <a
                href={
                  mappedBusiness.social.website?.startsWith("http")
                    ? mappedBusiness.social.website
                    : `https://${mappedBusiness.social.website}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className="w-full h-full flex items-center justify-center hover:opacity-80 transition-opacity duration-200"
                title={`Visit ${mappedBusiness.name} website`}
              >
                <img
                  src={mappedBusiness.logo || imgSrc}
                  alt={mappedBusiness.isBusiness ? "Business Logo" : "Profile"}
                  className="w-full h-full object-contain rounded-lg"
                  style={{
                    minWidth: "100%",
                    minHeight: "100%",
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                  onLoad={(e) => {
                    const img = e.target;
                    // Reset any previous inline styles
                    img.style.width = "";
                    img.style.height = "";
                    img.style.objectFit = "contain";
                    
                    const isWide = img.naturalWidth > img.naturalHeight * 1.2;
                    const isTall = img.naturalHeight > img.naturalWidth * 1.2;

                    if (isWide) {
                      img.style.width = "100%";
                      img.style.height = "auto";
                      img.style.maxHeight = "100%";
                    } else if (isTall) {
                      img.style.width = "auto";
                      img.style.height = "100%";
                      img.style.maxWidth = "100%";
                    } else {
                      img.style.width = "100%";
                      img.style.height = "100%";
                    }
                  }}
                  onError={() =>
                    setImgSrc(
                      mappedBusiness.businessLogoUrl ||
                        (mappedBusiness.isBusiness
                          ? "https://placehold.co/500x300?text=Logo"
                          : "https://placehold.co/300x300?text=P")
                    )
                  }
                />
              </a>
            ) : (
              <img
                src={mappedBusiness.logo || imgSrc}
                alt={mappedBusiness.isBusiness ? "Business Logo" : "Profile"}
                className="w-full h-full object-contain rounded-lg"
                style={{
                  minWidth: "100%",
                  minHeight: "100%",
                  maxWidth: "100%",
                  maxHeight: "100%",
                }}
                onLoad={(e) => {
                  const img = e.target;
                  // Reset any previous inline styles
                  img.style.width = "";
                  img.style.height = "";
                  img.style.objectFit = "contain";
                  
                  const isWide = img.naturalWidth > img.naturalHeight * 1.2;
                  const isTall = img.naturalHeight > img.naturalWidth * 1.2;

                  if (isWide) {
                    img.style.width = "100%";
                    img.style.height = "auto";
                    img.style.maxHeight = "100%";
                  } else if (isTall) {
                    img.style.width = "auto";
                    img.style.height = "100%";
                    img.style.maxWidth = "100%";
                  } else {
                    img.style.width = "100%";
                    img.style.height = "100%";
                  }
                }}
                onError={() =>
                  setImgSrc(
                    mappedBusiness.businessLogoUrl ||
                      (mappedBusiness.isBusiness
                        ? "https://placehold.co/500x300?text=Logo"
                        : "https://placehold.co/300x300?text=P")
                  )
                }
              />
            )}
          </div>
        </div>
        <div className="flex flex-col items-start flex-1 min-w-0">
          {mappedBusiness.social.website ? (
            <a
              href={
                mappedBusiness.social.website?.startsWith("http")
                  ? mappedBusiness.social.website
                  : `https://${mappedBusiness.social.website}`
              }
              target="_blank"
              rel="noopener noreferrer"
              className="text-[20px] leading-[30px] font-semibold text-[#333] hover:text-[#428BCA] transition-colors duration-200 text-wrap hover:underline"
              title={`Visit ${mappedBusiness.name} website`}
            >
              {mappedBusiness.name}
            </a>
          ) : (
            <h3 className="text-[20px] leading-[30px] font-semibold text-[#333] text-wrap">
              {mappedBusiness.name}
            </h3>
          )}
          {!mappedBusiness.isBusiness && (
            <span className="text-[#333] font-normal text-sm text-wrap">
              {mappedBusiness.company_name}
            </span>
          )}
          {mappedBusiness.subtitle && (
            <div className="flex  flex-col items-start gap-1 flex-wrap">
              <span
                className="text-[#428BCA] font-medium text-sm text-wrap"
                title={mappedBusiness.subtitle.value}
              >
                {mappedBusiness.subtitle.value}
              </span>
              {mappedBusiness.services &&
                mappedBusiness.services !== mappedBusiness.subtitle.value && (
                  <span className="text-[#333] font-normal text-sm text-wrap">
                    {mappedBusiness.services}
                  </span>
                )}
            </div>
          )}
        </div>
      </div>
      <div className="w-full mt-1 mb-2 text-sm">
        <p className="text-[#333] text-left text-sm leading-[20px] break-words">
          {mappedBusiness.details}
        </p>

        <div
          className={`flex flex-wrap items-center gap-3 ${
            mappedBusiness.details ? "mt-2" : ""
          } text-[#555] text-sm leading-[22px] mb-5`}
        >
          {/* Phone clickable */}
          {mappedBusiness.contact && (
            <>
              <a
                href={`tel:${mappedBusiness.contact}`}
                className="flex items-center gap-1.5 whitespace-pre-wrap hover:underline"
                title="Call"
              >
                <img src={PhoneIcon} alt="Phone" className="w-4 h-4" />
                {mappedBusiness.contact}
              </a>
              {(mappedBusiness.email ||
                mappedBusiness.industryTypes.length > 0) && (
                <span className="text-gray-400 text-lg">•</span>
              )}
            </>
          )}
          {/* Email clickable */}
          {mappedBusiness.email && (
            <>
              <a
                href={`mailto:${mappedBusiness.email}`}
                className="flex items-center gap-1.5 whitespace-pre-wrap hover:underline"
                title="Email"
              >
                <img src={EmailIcon} alt="Email" className="w-4 h-4" />
                {mappedBusiness.email}
              </a>
              {mappedBusiness.industryTypes.length > 0 && (
                <span className="text-gray-400 text-lg">•</span>
              )}
            </>
          )}
          {/* Industry type */}
          {mappedBusiness.industryTypes.length > 0 && (
            <span className="flex items-center gap-1.5 whitespace-pre-wrap">
              <img src={IndustryIcon} alt="Industry" className="w-4 h-4" />
              {mappedBusiness.industryTypes.join(", ")}
            </span>
          )}
        </div>
        {/* <div className="w-full mt-1 mb-2 text-sm">
          {mappedBusiness.occupation && (
            <p className="text-[#666] text-left text-sm mb-2 italic leading-[20px]">
              occupation: {mappedBusiness.occupation}
            </p>
          )}
          {mappedBusiness.other_service && (
            <p className="text-[#666] text-left text-sm mb-2 italic leading-[20px]">
              Other services: {mappedBusiness.other_service}
            </p>
          )}

          {mappedBusiness.designation && (
            <p className="text-[#666] text-left text-sm mb-2 italic leading-[20px]">
              designation: {mappedBusiness.designation}
            </p>
          )}
        </div> */}

        <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
          <div className="flex flex-wrap gap-2 max-w-full">
            {mappedBusiness?.badges &&
              mappedBusiness.badges.map((badge, idx) => {
                const baseClasses =
                  "px-4 py-1 rounded-md text-sm font-semibold shadow-sm";
                const badgeMap = {
                  "women-owned": "bg-[#F7E8F4] text-[#A60081]",
                  mappedBusiness: "bg-[#F4EFE0] text-[#A68100]",
                  new: "bg-[#FBE7E2] text-[#F55B4E]",
                  "woman-owned": "bg-[#F7E8F4] text-[#A60081]",
                  professional: "bg-[#eaf3ff] text-[#234075]",
                };
                const normalized = badge.toLowerCase().replace(/\s+/g, "-");
                return (
                  <span
                    key={idx}
                    className={`${baseClasses} ${
                      badgeMap[normalized] || "bg-[#fff7e0] text-[#6b5b2c]"
                    } flex items-center justify-center`}
                    title={badge}
                  >
                    {badgeMap[normalized] === badgeMap["woman-owned"] ? (
                      <img src={WomenOwnedIcon} alt="" />
                    ) : (
                      ""
                    )}
                    {badge}
                  </span>
                );
              })}
          </div>

          <div className="flex gap-3 items-center mt-3 sm:mt-0 flex-wrap">
            {mappedBusiness.social.linkedin && (
              <a
                href={mappedBusiness.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                title="LinkedIn"
                className="flex-shrink-0"
              >
                <img src={LinkedInIcon} alt="LinkedIn" className="w-6 h-6" />
              </a>
            )}
            {mappedBusiness.social.facebook && (
              <a
                href={mappedBusiness.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                title="Facebook"
                className="flex-shrink-0"
              >
                <img src={FacebookIcon} alt="Facebook" className="w-6 h-6" />
              </a>
            )}
            {mappedBusiness.social.website && (
              <a
                href={
                  mappedBusiness.social.website?.startsWith("http")
                    ? mappedBusiness.social.website
                    : `https://${mappedBusiness.social.website}`
                }
                target="_blank"
                rel="noopener noreferrer"
                title="Website"
                className="flex-shrink-0"
              >
                <img src={GlobeIcon} alt="Website" className="w-6 h-6" />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessCard;
